import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ontruck/orc';

import Modal from 'components/layout/Modal';

const TimeErrorModal = ({
  className,
  label,
  submitLabel,
  cancelLabel,
  navigateToForm,
  discardOrder,
}) => (
  <Modal closeButton={false} show size="S" fullHeight>
    <div className={className}>
      <img src="/time.png" alt={label} />
      <span className="label">{label}</span>

      <Button onClick={navigateToForm} text={submitLabel} fullWidth />
      <Button onClick={discardOrder} text={cancelLabel} fullWidth ghost />
    </div>
  </Modal>
);

TimeErrorModal.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  submitLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  navigateToForm: PropTypes.func,
  discardOrder: PropTypes.func,
};

TimeErrorModal.defaultProps = {
  className: '',
  label: '',
  submitLabel: '',
  cancelLabel: '',
  navigateToForm: () => ({}),
  discardOrder: () => ({}),
};

export default TimeErrorModal;
